import * as React from 'react'
import { useDispatch } from 'react-redux'
import { resetAppState, resetFormState, updateFormState, resetTabState, resetCustomVinInputState } from 'redux/slices/appSlice'
import { resetCallHistoryEvents } from 'redux/callHistory/callHistorySlice'
import { resetConnectedSearchState } from 'redux/slices/kongSlice'
import { resetCurrentEvent } from 'redux/currentEvent/currentEventSlice'
import { resetExchangeSearchState } from 'redux/slices/kongSlice'
import { resetEntegralState, resetFleetVehicleState } from 'redux/slices/kongSlice'
import { FormStore } from 'types/form'
import { resetLocations } from 'redux/location/locationSlice'
import { resetMapState } from 'redux/map/mapSlice'
import { resetTempMarkerState } from 'redux/tempMarker/tempMarkerSlice'
import { resetTicket } from 'redux/slices/kongSlice'
import useTimerState from 'hooks/useTimerState'
import { cloneDeep } from 'lodash'
import { resetRecentDispatches } from 'redux/recentDispatch/recentDispatchSlice'

export const useReduxCallStoreActions = () => {
  const dispatch = useDispatch()
  const timerstate = useTimerState()
  const localFormStore = localStorage.getItem('localFormStore')
  const [actions] = React.useState({
    update: (payload: Partial<FormStore>) => {
      localStorage.setItem(
        'localFormStore',
        cloneDeep(JSON.stringify({ ...(localFormStore && JSON.parse(localFormStore)), ...payload })),
      )
      dispatch(updateFormState({ ...(localFormStore && JSON.parse(localFormStore)), ...payload }))
    },
    reset: () => {
      dispatch(resetAppState())
      dispatch(resetMapState())
      dispatch(resetExchangeSearchState())
      dispatch(resetFormState())
      dispatch(resetFleetVehicleState())
      dispatch(resetTabState())
      dispatch(resetConnectedSearchState())
      dispatch(resetLocations())
      dispatch(resetTicket({}))
      dispatch(resetTempMarkerState())
      dispatch(resetEntegralState())
      dispatch(resetCurrentEvent())
      dispatch(resetCallHistoryEvents())
      dispatch(resetConnectedSearchState())
      dispatch(resetCustomVinInputState())
      dispatch(resetRecentDispatches())
      timerstate.set({})
      localStorage.removeItem('localFormStore') // Remove Caller specific form items
    },
  })
  return actions
}

export default useReduxCallStoreActions
